import * as yup from 'yup'

export const schema = yup.object().shape({
    cep: yup
        .string()
        .required()
        .matches(/[0-9]{5}-[0-9]{3}/),
    logradouro: yup.string().required(),
    numero: yup.string().required(),
    municipio: yup.string().required(),
    bairro: yup.string().required(),
    uf: yup.string().required(),
    complementoo: yup.string(),
    tipoEndereco: yup.string().required('Tipo é um campo obrigatório')
})
